import firebase from 'firebase';
import firestore from 'firebase/firestore';

var config = {
    apiKey: "AIzaSyAt0uFyID1KGp2iJmQ-tH1qGJOUgNBuOWs",
    authDomain: "ninja-chat-362ea.firebaseapp.com",
    databaseURL: "https://ninja-chat-362ea.firebaseio.com",
    projectId: "ninja-chat-362ea",
    storageBucket: "ninja-chat-362ea.appspot.com",
    messagingSenderId: "947267034056"
  };
  

  const firebaseApp = firebase.initializeApp(config);
  firebaseApp.firestore().settings({ timestampsInSnapshots: true})

  export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js